/* eslint-disable no-undef */
jQuery(function ($) {
  const url = window.location.href
  $('input.wpcf7-form-control.wpcf7-hidden[name="sent_from_url"]').attr('value', url)
})
